<template>
  <a-spin
    :spinning="isLoading"
    class="custom-spinner"
    style="height: 100vh; top: 20%"
  >
    <administrator-project-layout :model="model">
      <template #underInfo>
        <div class="administrator-project__common-progress" v-if="model.id">
          <progress-bar-generated
            :show-label="true"
            :completed="model.completedCount"
            :completed-overdue="model.completedOverdueCount"
            :incomplete-overdue="model.incompleteOverdueCount"
            :incomplete="model.incompleteCount"
          />
        </div>
      </template>
      <project-showcase-form :showcase="model.showcase">
        <administrator-showcase-agreement-form
          v-if="showAgreement"
          :showcase="model.showcase"
          :publicShowcase="model.publicShowcase"
          @update="onUpdate"
        />
      </project-showcase-form>
    </administrator-project-layout>
  </a-spin>
</template>

<script setup>
  import { computed, onMounted, reactive, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { useApi } from '@/api/use-api';
  import ProjectShowcaseForm from '@/components/projects/showcase/ProjectShowcaseForm.vue';
  import AdministratorProjectLayout from '@/views/administrator/projects/components/AdministratorProjectLayout.vue';
  import AdministratorShowcaseAgreementForm from './components/AdministratorShowcaseAgreementForm.vue';
  import { SHOWCASE_STATUS_ID_DRAFT } from '@/api/models/ProjectShowcaseStatus';
  import ProgressBarGenerated from '@/components/projects/portfolio/components/ProgressBarGenerated.vue';

  const api = useApi();
  const emit = defineEmits(['update']);
  const route = useRoute();
  const model = reactive({
    id: null,
    number: '',
    name: '',
    projectType: '',
    requestId: null,
    status: null,
    projectStatusId: null,
    showcase: null,
    publicShowcase: null,
    isMyProject: false,
    completedCount: 0,
    completedOverdueCount: 0,
    incompleteOverdueCount: 0,
    incompleteCount: 0,
  });
  const isLoading = ref(true);

  const showAgreement = computed(() => {
    return (
      model.isMyProject &&
      ((model.showcase?.statusId === SHOWCASE_STATUS_ID_DRAFT &&
        model.publicShowcase?.statusId !== SHOWCASE_STATUS_ID_DRAFT) ||
        model.showcase?.statusId !== SHOWCASE_STATUS_ID_DRAFT)
    );
  });

  onMounted(async () => {
    await getModel();
    await getShowcase();
    await getPublicShowcase();
    isLoading.value = false;
  });

  const getModel = async () => {
    try {
      const response = await api.administratorPage.getProject(route.params.id);
      model.name = response.project.name;
      model.number = response.project.id;
      model.id = response.project.id;
      model.type = response.project.type;
      model.requestId = response.project.requestId;
      model.status = response.project.status;
      model.projectStatusId = response.project.projectStatusId;
      model.isMyProject = response.project.isMyProject;
      model.completedCount = response.project.completedCount;
      model.completedOverdueCount = response.project.completedOverdueCount;
      model.incompleteOverdueCount = response.project.incompleteOverdueCount;
      model.incompleteCount = response.project.incompleteCount;
    } catch (error) {
      console.error('error', error);
    }
  };

  const getShowcase = async () => {
    try {
      const response = await api.showcase.getDraft(route.params.id);
      model.showcase = response.showcase;
    } catch (error) {
      console.error('error', error);
    }
  };

  const getPublicShowcase = async () => {
    try {
      const response = await api.showcase.getPublic(route.params.id);
      model.publicShowcase = response.showcase;
    } catch (error) {
      console.log('error', error);
    }
  };

  const onUpdate = async () => {
    await getShowcase();
    await getPublicShowcase();
    emit('update');
  };
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;

  * {
    margin: 0;
    padding: 0;
  }

  .ant-input {
    font-family: 'Nunito Sans', sans-serif;
    &[disabled] {
      color: $color-text-primary;
    }
  }

  .leader-project__common-progress {
    margin-top: 42px;
  }
</style>
